import messages from './shell.json' with { type: 'json' };

export const shellFi: Readonly<typeof messages> = messages;
